export default "__VITE_ASSET__DcWuPLLO__"